import {OnShowError} from "@baseTypes/base";
import {BASE_TRACK_API_URL} from "@constants/config";
import {apiRequestWithAuth} from "@helpers/query/apiRequestWithAuth";
import {ISingleVoyage} from "@containers/singleVoyage/types/voyage";
import {
	IBodyCreateVoyageFromTemplateSingleVoyage,
	IBodyCreateVoyageTemplateFromVoyageSingleVoyage,
	IBodySaveVoyageTemplateSingleVoyage,
	IBodySyncVoyagesVoyageTemplate,
	IPropsGetVoyageTemplateByIdSingleVoyage,
	IPropsGetVoyageTemplatesSingleVoyage,
	IPropsSyncPreviewVoyageTemplate,
	ISyncItemVoyageTemplate,
	IVoyageTemplateListItemSingleVoyage,
	IVoyageTemplateSingleVoyage,
} from "@containers/singleVoyage/voyageTemplates/types";

const buildUrl = (accountId: string | number) =>
	`${BASE_TRACK_API_URL}/v1/accounts/${accountId}/single-voyage/voyage-templates`

export const getVoyageTemplatesSingleVoyage = async (
	{accountId, waypointTemplateId}: IPropsGetVoyageTemplatesSingleVoyage,
	onError?: OnShowError
): Promise<IVoyageTemplateListItemSingleVoyage[]> => {
	return apiRequestWithAuth({
		url: waypointTemplateId
			? `${buildUrl(accountId)}?waypointTemplateId=${waypointTemplateId}`
			: buildUrl(accountId),
		options: {
			method: "GET",
		},
		onError,
	});
}

export const getVoyageTemplateByIdSingleVoyage = async (
	{accountId, id}: IPropsGetVoyageTemplateByIdSingleVoyage,
	onError?: OnShowError
): Promise<IVoyageTemplateSingleVoyage> => {
	return apiRequestWithAuth({
		url: `${buildUrl(accountId)}/${id}`,
		options: {
			method: "GET",
		},
		onError,
	});
}

export const saveVoyageTemplateSingleVoyage = async ({
														 accountId,
														 id,
														 ...body
													 }: IBodySaveVoyageTemplateSingleVoyage): Promise<IVoyageTemplateSingleVoyage> => {
	return apiRequestWithAuth({
		url: id ? `${buildUrl(accountId)}/${id}` : buildUrl(accountId),
		options: {
			method: id ? "PUT" : "POST",
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body)
		},
	});
}

export const createVoyageFromTemplateSingleVoyage = async ({
															   accountId,
															   templateId,
															   ...body
														   }: IBodyCreateVoyageFromTemplateSingleVoyage): Promise<ISingleVoyage> => {
	return apiRequestWithAuth({
		url: `${buildUrl(accountId)}/${templateId}/voyages`,
		options: {
			method: "POST",
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body)
		},
	});
}

export const createVoyageTemplateFromVoyageSingleVoyage = async ({
																	 accountId,
																	 voyageId,
																	 ...body
																 }: IBodyCreateVoyageTemplateFromVoyageSingleVoyage): Promise<IVoyageTemplateSingleVoyage> => {
	return apiRequestWithAuth({
		url: `${buildUrl(accountId)}/from-voyage/${voyageId}`,
		options: {
			method: "POST",
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body)
		},
	});
}

export const deleteVoyageTemplateSingleVoyage = async ({id, accountId}: {
	id: number | string,
	accountId: number | string
}) => {
	return apiRequestWithAuth({
		url: `${buildUrl(accountId)}/${id}`,
		options: {
			method: "DELETE",
		},
	});
}

export const getSyncPreviewVoyageTemplateSingleVoyage = async (
	{accountId, templateId}: IPropsSyncPreviewVoyageTemplate,
	onError?: OnShowError
): Promise<ISyncItemVoyageTemplate[]> => {
	return apiRequestWithAuth({
		url: `${buildUrl(accountId)}/${templateId}/voyages/sync-preview`,
		options: {
			method: "GET",
		},
		onError,
	});
}

export const syncVoyagesVoyageTemplateSingleVoyage = async ({
																accountId,
																templateId,
																...body
															}: IBodySyncVoyagesVoyageTemplate): Promise<ISyncItemVoyageTemplate[]> => {
	return apiRequestWithAuth({
		url: `${buildUrl(accountId)}/${templateId}/voyages/sync`,
		options: {
			method: "POST",
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body)
		},
	});
}
